// Path calculation utilities for MTO CustomMode

// Calculate distance between two points using Manhattan formula
export const calculateManhattanDistance = (point1, point2) => {
  // Convert degree differences to approximate kilometers
  const lat_diff = Math.abs(point2.latitude - point1.latitude);
  const lng_diff = Math.abs(point2.longitude - point1.longitude);
  
  // Approximate conversion: 1 degree ≈ 111 km
  const lat_km = lat_diff * 111.0;
  const lng_km = lng_diff * 111.0;
  
  // Manhattan distance in kilometers
  return lat_km + lng_km;
};

// Calculate total path distance
export const calculatePathDistance = (customPath) => {
  if (customPath.length < 2) return 0;
  
  let distance = 0;
  for (let i = 0; i < customPath.length - 1; i++) {
    const point1 = customPath[i];
    const point2 = customPath[i + 1];
    distance += calculateManhattanDistance(point1, point2);
  }
  
  return distance.toFixed(2);
};

// Calculate total path duration based on connections
export const calculatePathDuration = (customPath, connections) => {
  if (customPath.length < 2 || !connections || connections.length === 0) return 0;
  
  let totalDuration = 0;
  
  for (let i = 0; i < customPath.length - 1; i++) {
    const point1 = customPath[i];
    const point2 = customPath[i + 1];
    
    // Find the connection between these two points
    const connection = connections.find(conn => {
      if (!conn.points || conn.points.length !== 2) return false;
      
      const [connPoint1, connPoint2] = conn.points;
      
      // Check both directions of the connection
      return (
        (connPoint1.id === point1.id && connPoint2.id === point2.id) ||
        (connPoint2.id === point1.id && connPoint1.id === point2.id)
      );
    });
    
    if (connection && connection.duration) {
      totalDuration += parseFloat(connection.duration);
    }
  }
  
  return totalDuration.toFixed(1);
};

// Get remaining points that are not yet in the path
export const getRemainingPoints = (availablePoints, customPath) => {
  if (customPath.length === 0) return availablePoints;
  
  return availablePoints.filter(point => 
    !customPath.some(pathPoint => pathPoint.id === point.id)
  );
};

// Get points that are connected to the last point in the path
export const getConnectedPoints = (availablePoints, customPath, connections) => {
  if (customPath.length === 0) return availablePoints;
  
  // Get the last point in the current path
  const lastPoint = customPath[customPath.length - 1];
  
  // Get remaining points (not yet in path)
  const remainingPoints = getRemainingPoints(availablePoints, customPath);
  
  // Find points that are connected to the last point
  const connectedPoints = remainingPoints.filter(point => {
    // Check if there's a connection between lastPoint and this point
    return connections.some(connection => {
      if (!connection.points || connection.points.length !== 2) return false;
      
      const [point1, point2] = connection.points;
      
      // Check both directions of the connection
      return (
        (point1.id === lastPoint.id && point2.id === point.id) ||
        (point2.id === lastPoint.id && point1.id === point.id)
      );
    });
  });
  
  return connectedPoints;
};
